<div class="allergen-pill" [class.plain]="plain" *ngIf="allergens.length">
  <span class="allergen-pill__item" *ngFor="let allergen of shown" (click)="show(allergen, $event)">
    <app-allergen-icon [allergen]="allergen" [size]="size"></app-allergen-icon>
    <span class="allergen-pill__tip" *ngIf="active === allergen">{{ allergen | allergenTranslate }}</span>
  </span>
  <span class="allergen-pill__item allergen-pill__more" *ngIf="hidden.length" (click)="show('more', $event)">
    +{{ hidden.length }}
    <span class="allergen-pill__tip" *ngIf="active === 'more'">{{ hiddenTitles }}</span>
  </span>
</div>
